import React, {Component} from 'react'
import 'antd/dist/antd.css'
import './assets/scss/compile/bootstrap.scss'
import './assets/scss/compile/bootstrap_limitless.scss'
import './assets/scss/compile/colors.scss'
import './assets/scss/compile/components.scss'
import './assets/scss/compile/layout.scss'
import './assets/scss/styles.scss'
import './assets/css/icons/fontawesome/styles.min.css'
import './assets/css/icons/icomoon/styles.css'
import './assets/css/icons/material/icons.css'
import Main from './layouts/Main/Main'
import config from './configs/config'

class App extends Component {
    componentDidMount() {
        document.title = config.siteName
    }

    render() {
        const {...rest} = this.props

        return (
            <div className="App">
                <Main {...rest}/>
            </div>
        )
    }
}

export default App
